import React from 'react'

const NoDataPlaceholder = ({text="No Data Found!"}) => {
  return (
    <div>{text}</div>
  )
}

export default NoDataPlaceholder